"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  computedWH: true,
  fetchBuffer: true,
  getOs: true
};
exports.getOs = exports.fetchBuffer = exports.default = exports.computedWH = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _dataMap = require("./dataMap");

Object.keys(_dataMap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dataMap[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dataMap[key];
    }
  });
});

var computedWH = function computedWH(clientWidth, clientHeight, viewportRatio) {
  var width;
  var height;

  if (clientHeight / clientWidth === viewportRatio) {
    width = clientWidth;
    height = clientHeight;
  } else if (clientHeight / clientWidth > viewportRatio) {
    width = clientWidth;
    height = clientWidth * viewportRatio;
  } else {
    width = clientHeight / viewportRatio;
    height = clientHeight;
  }

  return {
    width: "".concat(width, "px"),
    height: "".concat(height, "px")
  };
};

exports.computedWH = computedWH;
var _default = {};
exports.default = _default;

var fetchBuffer = function fetchBuffer(url) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120000;
  return new Promise(function (resolve, reject) {
    if (!url) {
      reject(new Error("no url provided for ".concat(url)));
      return;
    }

    return fetchWithTimeout(url, {
      timeout: timeout
    }).then(function (res) {
      return resolve(res.arrayBuffer());
    }).catch(reject);
  });
};

exports.fetchBuffer = fetchBuffer;

var fetchWithTimeout = function fetchWithTimeout(resource) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve, reject) {
    var _options$timeout = options.timeout,
        timeout = _options$timeout === void 0 ? 8000 : _options$timeout;
    var controller = new AbortController();
    var id = setTimeout(function () {
      return controller.abort();
    }, timeout);
    fetch(resource, (0, _extends2.default)((0, _extends2.default)({}, options), {
      signal: controller.signal
    })).then(function (res) {
      resolve(res);
      clearTimeout(id);
    }).catch(reject);
  });
};

var getOs = function getOs() {
  var _a, _b, _c;

  if ((_a = window) === null || _a === void 0 ? void 0 : _a.Electron_CoreOptions) {
    console.log('【组件库】当前在多标签软件中');

    var _ref = (_b = window) === null || _b === void 0 ? void 0 : _b.Electron_CoreOptions,
        arch = _ref.arch,
        platform = _ref.platform;

    if (platform === 'darwin' || platform === 'safari') {
      return 'OS X';
    }

    if (platform === 'win32' || platform === 'chrome' || platform === 'ie' || platform === 'firefox' || platform === 'opera') {
      if (arch === 'x64' || arch === 'arm64') {
        return 'win64';
      }

      return 'win32';
    }
  } else {
    return (_c = window) === null || _c === void 0 ? void 0 : _c.os;
  }
};

exports.getOs = getOs;